/* ========================================================
   WRATH & REMEDY — SUBSCRIPTION WIDGET ENHANCER  (site-wide)

   FIX: keeps the "Most Popular / Deliver every month" plan selected
   (and therefore the beige fill, via CSS :has(input:checked)) after the
   shopper changes a variant. The Shopify Subscriptions app re-renders the
   widget on every variant change and resets it to "one-time" — sometimes
   AFTER our click — so a single preselect loses the race. This version
   re-applies on a short self-healing schedule and only backs off when the
   shopper deliberately picks a plan themselves.

   INSTALL (unchanged): Assets → wr-subscription-widget.js (replace contents).
   Loaded via <script src="{{ 'wr-subscription-widget.js' | asset_url }}" defer></script>
   ======================================================= */
(function () {
  var CONFIG = {
    cardSelector:  '.plan_card',
    labelSelector: 'label'
  };

  var MOST_POPULAR_MATCH = /every month/i;        // which plan to preselect
  var DISCOUNT_RE        = /,?\s*\d+\s*%\s*off/i;  // strip inline "x% off" from label

  // We force the monthly plan after every variant re-render, UNTIL the shopper
  // deliberately picks a different plan themselves.
  var forceMonthly = true;

  /* ---------------- helpers ---------------- */

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent !== null) return true;
    var r = el.getBoundingClientRect();           // offsetParent is null for fixed/0-size
    return r.width > 0 && r.height > 0;
  }

  // The app pre-renders a separate .plan_card per variant; only one is visible.
  function getVisibleCard() {
    var cards = document.querySelectorAll(CONFIG.cardSelector);
    for (var i = 0; i < cards.length; i++) {
      if (isVisible(cards[i])) return cards[i];
    }
    return cards[0] || null;
  }

  function findMonthlyLi(card) {
    if (!card) return null;
    var items = card.querySelectorAll('.group_list li');
    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector(CONFIG.labelSelector);
      if (label && MOST_POPULAR_MATCH.test(label.textContent)) return items[i];
    }
    return null;
  }

  function monthlyChecked(card) {
    var li = findMonthlyLi(card);
    var input = li && li.querySelector('input[type="radio"]');
    return !!(input && input.checked);
  }

  /* ---------------- visual enhancements (badges, price move, popular pill) ---------------- */

  function stripDiscountText(label) {
    var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (DISCOUNT_RE.test(node.textContent)) {
        node.textContent = node.textContent.replace(DISCOUNT_RE, '')
                                           .replace(/\s{2,}/g, ' ').trim();
      }
    }
  }

  function enhanceCard(card) {
    if (!card) return;
    var items = card.querySelectorAll('.group_list li');
    items.forEach(function (li) {
      var label = li.querySelector(CONFIG.labelSelector);
      if (!label) return;

      if (!li.dataset.wrPct) {
        var m = label.textContent.match(/(\d+)\s*%\s*off/i);
        if (m) li.dataset.wrPct = m[1];
      }

      stripDiscountText(label);

      // Right-side stack: "% OFF" badge on top, price beneath it.
      var right = li.querySelector('.sub-right');
      if (li.dataset.wrPct && !right) {
        right = document.createElement('span');
        right.className = 'sub-right';
        var badge = document.createElement('span');
        badge.className = 'save-badge';
        badge.textContent = li.dataset.wrPct + '% OFF';
        right.appendChild(badge);
        li.appendChild(right);
      }

      var price = li.querySelector('.in_widget_price');
      if (price && right && price.parentElement !== right) {
        right.appendChild(price);
      }

      if (MOST_POPULAR_MATCH.test(label.textContent) && !li.querySelector('.sub-most-pop')) {
        li.classList.add('sub-best');
        var pill = document.createElement('span');
        pill.className = 'sub-most-pop';
        pill.textContent = '\u2605 Most Popular';
        li.insertBefore(pill, li.firstChild);
      }
    });
  }

  function enhanceAll() {
    document.querySelectorAll(CONFIG.cardSelector).forEach(enhanceCard);
  }

  /* ---------------- self-healing monthly preselect ---------------- */

  function applyMonthly() {
    if (!forceMonthly) return;
    var card = getVisibleCard();
    if (!card) return;
    var li = findMonthlyLi(card);
    if (!li) return;                              // widget mid-render — a later tick will get it
    var input = li.querySelector('input[type="radio"]');
    if (input && !input.checked) input.click();   // programmatic → not isTrusted → won't count as a shopper pick
  }

  // The app can reset the widget to "one-time" AFTER our click, so we don't
  // trust a single attempt. Re-apply across a ~1.6s window; once the app's
  // init settles, our selection sticks. Aborts instantly if the shopper picks.
  var healTimers = [];
  function clearHeal() { healTimers.forEach(clearTimeout); healTimers = []; }

  function healMonthly() {
    clearHeal();
    [0, 60, 150, 300, 500, 800, 1200, 1600].forEach(function (delay) {
      healTimers.push(setTimeout(function () {
        if (!forceMonthly) return;               // shopper took over — leave it alone
        enhanceAll();
        applyMonthly();
      }, delay));
    });
  }

  /* ---------------- wiring ---------------- */

  function isVariantChange(t) {
    if (!t) return false;
    if (t.matches && t.matches('.button-input__input, [name="id"], select[name="id"]')) return true;
    return !!(t.closest && t.closest('variant-selects, variant-radios, .product-variant-picker, .product-form__input'));
  }

  function start() {
    enhanceAll();
    healMonthly();

    // body is stable; the product section is REPLACED on variant change, so
    // observing body (not the section) always catches the fresh widget.
    new MutationObserver(function () {
      enhanceAll();
      if (forceMonthly) applyMonthly();
    }).observe(document.body, { childList: true, subtree: true });

    // A TRUSTED click inside the plan card = the shopper deliberately choosing
    // a plan → stop forcing monthly and respect their pick. Programmatic clicks
    // (our own applyMonthly, or the app's resets) are not isTrusted, so ignored.
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      if (e.target.closest && e.target.closest(CONFIG.cardSelector)) {
        forceMonthly = false;
        clearHeal();
      }
    }, true);

    // A real variant change re-renders + resets the widget → re-arm + re-heal.
    // Scoped to variant inputs so unrelated inputs (quantity, etc.) don't
    // override a shopper who chose one-time.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(CONFIG.cardSelector)) return;   // in-card changes handled by the click logic
      if (isVariantChange(t)) {
        forceMonthly = true;
        healMonthly();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();